const RENDER_HEALTH_KEY = 'baobab_render_health';

export const RENDER_HEALTH_THRESHOLD = 3;
export const RENDER_HEALTH_WINDOW_MS = 600_000;
export const RENDER_SURVIVAL_MS = 5_000;

export interface RenderHealthState {
  count: number;
  firstArmedAt: number;
  bundleId: string;
}

let activeBundleId = '';

export const noteActiveBundleId = (id: string): void => {
  activeBundleId = id;
};

export const readRenderHealth = (): RenderHealthState | null => {
  try {
    const raw = localStorage.getItem(RENDER_HEALTH_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<RenderHealthState>;
    if (
      typeof p?.count !== 'number' ||
      typeof p?.firstArmedAt !== 'number' ||
      typeof p?.bundleId !== 'string'
    ) {
      return null;
    }
    return { count: p.count, firstArmedAt: p.firstArmedAt, bundleId: p.bundleId };
  } catch {
    return null;
  }
};

const write = (state: RenderHealthState): void => {
  try {
    localStorage.setItem(RENDER_HEALTH_KEY, JSON.stringify(state));
  } catch {
    // Best-effort only.
  }
};

export const clearRenderHealth = (): void => {
  try {
    localStorage.removeItem(RENDER_HEALTH_KEY);
  } catch {
    // Best-effort only.
  }
};

export const disarmRenderProbe = clearRenderHealth;

// Called immediately before setIsReady(true) — i.e.
export const armRenderProbe = (now: number): void => {
  if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
  if (!activeBundleId) return;
  const previous = readRenderHealth();
  if (
    !previous ||
    previous.bundleId !== activeBundleId ||
    now - previous.firstArmedAt > RENDER_HEALTH_WINDOW_MS
  ) {
    write({ count: 1, firstArmedAt: now, bundleId: activeBundleId });
    return;
  }
  write({ count: previous.count + 1, firstArmedAt: previous.firstArmedAt, bundleId: activeBundleId });
};
